import { render, staticRenderFns } from "./KikiGame.vue?vue&type=template&id=42d8e34e&"
import script from "./KikiGame.vue?vue&type=script&lang=js&"
export * from "./KikiGame.vue?vue&type=script&lang=js&"
import style0 from "./KikiGame.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports